import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as d, useEffect as m } from "react";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as v, d as f } from "./constants-CnFYFetN.mjs";
class u {
  constructor(i, t = 30, s = !0) {
    this.target = i.parentElement ?? document.createElement("div"), this.canvas = i, this.context = i.getContext("2d"), this.drawInterval = 0, this.setRelative = s, this.numParticles = t, this.particles = [], this.angle = 0, this.tiltAngle = 0, this.standardElapsedTime = 13.346, this.initialize(), this.start();
  }
  initialize() {
    this.setDimensions(), this.setRelative && (this.target.style.position = "relative");
    for (let i = 0; i < this.numParticles; i++)
      this.particles.push(this.getNewParticle());
    window.addEventListener("resize", this.setDimensions.bind(this));
  }
  setDimensions() {
    this.canvas.width = this.target.clientWidth, this.canvas.height = this.target.clientHeight;
  }
  draw(i) {
    if (this.context) {
      this.previousTimeStamp === void 0 ? (this.previousTimeStamp = i, this.elapsedTime = this.standardElapsedTime) : this.elapsedTime = i - this.previousTimeStamp, this.deviationMultiplyer = this.elapsedTime / this.standardElapsedTime, this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      for (let t = 0; t < this.particles.length; t++) {
        const s = this.particles[t];
        this.context.beginPath(), this.context.lineWidth = s.size * 0.3, this.context.strokeStyle = s.color, this.context.moveTo(s.xPos + s.tilt + s.size * 0.25, s.yPos), this.context.lineTo(s.xPos + s.tilt, s.yPos + s.tilt * 0.5 + s.size * 0.1), this.context.stroke();
      }
      this.update(), this.previousTimeStamp = i, this.drawInterval = window.requestAnimationFrame(this.draw.bind(this));
    }
  }
  getNewParticle() {
    return {
      xPos: Math.random() * this.canvas.width,
      yPos: Math.random() * this.canvas.height,
      size: this.randomFromTo(5, 30),
      density: Math.random() * this.numParticles + 10,
      color: `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, 0.7)`,
      tilt: Math.floor(Math.random() * 10) - 10,
      tiltAngleIncremental: Math.random() * 0.04 + 0.03,
      tiltAngle: 0
    };
  }
  // eslint-disable-next-line class-methods-use-this
  randomFromTo(i, t) {
    return Math.floor(Math.random() * (t - i + 1) + i);
  }
  update() {
    this.angle += 0.01, this.tiltAngle += 0.1;
    for (let i = 0; i < this.particles.length; i++) {
      const t = this.particles[i];
      t.tiltAngle += t.tiltAngleIncremental * this.deviationMultiplyer, t.yPos += (Math.cos(this.angle + t.density) + 1 + t.size * 0.5) * 0.1 * this.deviationMultiplyer, t.xPos += Math.sin(this.angle) * 0.5 * this.deviationMultiplyer, t.tilt = Math.sin(t.tiltAngle - i / 3) * 15, (t.xPos > this.canvas.width + 15 || t.xPos < -15 || t.yPos > this.canvas.height + 15) && (t.tilt = Math.floor(Math.random() * 10) - 10, i % 5 > 0 || i % 2 === 0 ? (t.xPos = Math.random() * this.canvas.width, t.yPos = -10) : (t.yPos = Math.random() * this.canvas.height, Math.sin(this.angle) > 0 ? t.xPos = -5 : t.xPos = this.canvas.width + 5));
    }
  }
  start() {
    this.drawInterval = window.requestAnimationFrame(this.draw.bind(this));
  }
  stop() {
    this.drawInterval && window.cancelAnimationFrame(this.drawInterval), this.context && this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
}
const g = p({ name: "Confetti" })(({ mode: e }) => ({
  canvas: {
    outline: e === v.Dye ? `2px solid ${f.main}` : void 0,
    bottom: 0,
    left: 0,
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    top: 0
  }
})), y = ({
  children: e,
  canvasClass: i,
  numParticles: t = 30,
  setRelative: s = !0,
  isCelebrating: o = !0
}) => {
  const { classes: h, cx: r } = g(), a = d(null);
  return m(() => {
    if (a.current) {
      const l = a.current, c = new u(l, t, s);
      return () => {
        c.stop();
      };
    }
  }, [o, t, s]), /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    o && /* @__PURE__ */ n.jsx("canvas", { className: r(h.canvas, i), "data-fabric-component": "Confetti", ref: a }),
    e
  ] });
};
export {
  y as C
};
//# sourceMappingURL=confetti-CLazeHT_.mjs.map
